let quoteSlider;
export default () => ({
	autoplay: null,
	loop: null,
	speed: null,
	delay: null,

	createSlider() {
		let settings = {};
		if (this.autoplay) {
			settings = {
				slidesPerView: 1,
				loop: this.loop,
				speed: this.speed,
				autoplay: {
					delay: this.delay,
				},
				pagination: {
					el: '.quote-slider__pagination',
					clickable: true,
				},
			};
		} else {
			settings = {
				slidesPerView: 1,
				loop: this.loop,
				speed: this.speed,
				pagination: {
					el: '.quote-slider__pagination',
					clickable: true,
				},
			};
		}

		quoteSlider = new window.Swiper('.quote-slider__container', settings);
	},

	init() {
		this.$watch('autoplay', () => {
			this.createSlider();
		});
	},
});
